module.exports = __webpack_public_path__ + "static/img/qy.e8b3a2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qy.png
// module id = LSbw
// module chunks = 1